module.exports = "https://images.shiksha.ws/saassets/media/ContactUsHeadPhnIcn.f0c484c5.svg";